var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupSnsLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_col"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M127.491 41.1182C126.108 35.9519 122.048 31.892 116.882 30.5091C107.527 28 69.9998 28 69.9998 28C69.9998 28 32.4728 28 23.1182 30.5091C17.9519 31.892 13.892 35.9519 12.5091 41.1182C10 50.4728 10 70.002 10 70.002C10 70.002 10 89.5312 12.5091 98.8859C13.892 104.052 17.9519 108.112 23.1182 109.495C32.4728 112.004 69.9998 112.004 69.9998 112.004C69.9998 112.004 107.527 112.004 116.882 109.495C122.048 108.112 126.108 104.052 127.491 98.8859C130 89.5312 130 70.002 130 70.002C130 70.002 129.99 50.4728 127.491 41.1182Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M57.9922 88.0016L89.1677 70.0037L57.9922 52.0056V88.0016Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupSnsLogo2);
export default __webpack_public_path__ + "static/media/sup_sns_logo2.599c04578df6ddbeec173bf112457b82.svg";
export { ForwardRef as ReactComponent };